import React from 'react';
import styled from 'styled-components';
import {
  Globe,
  BookOpen, Wrench
} from 'lucide-react';

const TAB_META = {
  'google-maps':     { title: 'Google Maps',            icon: Globe,          color: '#34a853' },
  'google-reviews':  { title: 'Avis Google',            icon: BookOpen,       color: '#fbbc04' },
};

const Page = styled.div`
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  min-height: 60vh; padding: 40px;
`;

const IconWrap = styled.div`
  width: 80px; height: 80px; border-radius: 20px;
  background: ${p => p.$color ? `${p.$color}18` : 'var(--surface)'};
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 20px;
  svg { color: ${p => p.$color || 'var(--primary)'}; }
`;

const Title = styled.h2`
  font-size: 20px; font-weight: 700; color: var(--text-primary); margin-bottom: 8px;
`;

const Subtitle = styled.p`
  font-size: 14px; color: var(--text-muted); text-align: center; max-width: 400px;
  line-height: 1.5;
`;

const Badge = styled.div`
  margin-top: 20px; padding: 6px 16px; border-radius: 20px;
  background: rgba(165,145,239,.1); color: var(--primary);
  font-size: 12px; font-weight: 700; display: flex; align-items: center; gap: 6px;
`;

const PlaceholderPage = ({ tabId, selectedDevice }) => {
  const meta = TAB_META[tabId] || { title: tabId || 'Page', icon: Wrench, color: null };
  const Icon = meta.icon;

  return (
    <Page>
      <IconWrap $color={meta.color}>
        <Icon size={36} />
      </IconWrap>
      <Title>{meta.title}</Title>
      <Subtitle>
        Cette section est en cours de développement.
        {selectedDevice && (
          <><br />Appareil sélectionné : <strong>{selectedDevice.device_name || selectedDevice.device_id}</strong></>
        )}
      </Subtitle>
      <Badge><Wrench size={14} /> Bientôt disponible</Badge>
    </Page>
  );
};

export default PlaceholderPage;
